import { observer } from 'mobx-react-lite';
import { Alert } from '@mui/material';

import {
  NoParticipantsWrapper,
  ParticipantsRoot,
} from '@/dmdrive/topic/components/Topic/RightSidebar/Participants/Participants.styles';
import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';

import ParticipantRow from './ParticipantRow/ParticipantRow';

function Participants() {
  const { topic } = useTopicStore();

  if (topic?.topicUsersSorted.length === 0) {
    return (
      <NoParticipantsWrapper>
        <Alert icon={false} severity="warning">
          No participants here
        </Alert>
      </NoParticipantsWrapper>
    );
  }

  return (
    <ParticipantsRoot>
      {topic?.topicUsersSorted.map((user) => <ParticipantRow key={user.id} participant={user} />)}
    </ParticipantsRoot>
  );
}

export default observer(Participants);
